
import { ReducerRegistry } from '../base/redux';
import { SET_SHARE_MENU } from '../toolbox/actionTypes';

import {
    SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED,
    SET_CAR_MODE,
    SET_PRIORITY_CONTENT_STACK,
    SET_TILE_VIEW
} from './actionTypes';

const DEFAULT_STATE = {
    /**
     * Whether we are in carmode.
     *
     * @public
     * @type {boolean}
     */
    carMode: false,
    remoteScreenShares: [],
    isShareMenu: false,

    /**
     * The unified LIFO stack of currently active presentation items (screen share,
     * shared video, whiteboard, etherpad), ordered oldest-first. The topmost
     * pinnable item (last element) is auto-pinned to the large video.
     *
     * @public
     * @type {Array<{ id: string, type: string, timestamp: number }>}
     */
    priorityContentStack: [],

    /**
     * The indicator which determines whether the video layout should display
     * video thumbnails in a tiled layout.
     *
     * Note: undefined means that the user hasn't requested anything in particular yet, so
     * we use our auto switching rules.
     *
     * @public
     * @type {boolean}
     */
    tileViewEnabled: true
};

const STORE_NAME = 'features/video-layout';

ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case SET_CAR_MODE:
        return {
            ...state,
            carMode: action.enabled
        };
    case SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED: {
        return {
            ...state,
            remoteScreenShares: action.participantIds
        };
    }
    case SET_SHARE_MENU: {
        return {
            ...state,
            isShareMenu: action.visible
        };
    }

    case SET_PRIORITY_CONTENT_STACK:
        return {
            ...state,
            priorityContentStack: action.stack
        };

    case SET_TILE_VIEW:
        // Conference.componentDidUpdate dispatches this on every update; a new
        // slice for an unchanged value re-renders it and loops forever.
        if (state.tileViewEnabled === action.enabled) {
            return state;
        }

        return {
            ...state,
            tileViewEnabled: action.enabled
        };
    }

    return state;
});
